import React from 'react';
import CourseSearchInterface from '@/components/course/CourseSearchInterface';
import EnhancedBreadcrumbNavigation from '@/components/course/EnhancedBreadcrumbNavigation';

const CourseSearchPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-background">
      <EnhancedBreadcrumbNavigation />
      <div className="container mx-auto py-8">
        <CourseSearchInterface />
      </div>
    </div>
  );
};

export default CourseSearchPage;